import { render, staticRenderFns } from "./popup-result.mpx?vue&type=template&id=0603be01&scoped=true&isComponent&outputPath=components%2Fpopup-result004a2ee8%2Findex"
import script from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result004a2ee8%2Findex"
export * from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result004a2ee8%2Findex"
import style0 from "./popup-result.mpx?vue&type=style&index=0&id=0603be01&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m004a2ee8%22%7D&isComponent&outputPath=components%2Fpopup-result004a2ee8%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603be01",
  null
  
)

export default component.exports